import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as f } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as u } from "react";
import { Avatar as v } from "../../atoms/Avatars/Avatar.js";
import j from "../../atoms/Icon/Icon.js";
import { Typography as o } from "../../atoms/Typography/Typography.js";
import s from "./AvatarLabel.module.scss.js";
const g = (i) => {
  const {
    type: r = "default",
    size: m = "expanded",
    showDropdown: l = !0,
    className: n,
    headerText: t,
    supportingText: a = "",
    avatarProps: x,
    avatarLogo: c,
    iconProps: d,
    ...p
  } = i;
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: f(s.avatarLabelContainer, s[r], n),
      ...p,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-100", children: [
          /* @__PURE__ */ e.jsx(
            v,
            {
              tabIndex: -1,
              imageSrc: c,
              size: m === "expanded" ? "l" : "sm",
              ...x
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col	justify-center", children: [
            t && /* @__PURE__ */ e.jsx(
              o,
              {
                text: t,
                variant: r === "default" ? "interface/medium/sm" : "interface/default/sm",
                textColor: "color/fg/bold"
              }
            ),
            a && /* @__PURE__ */ e.jsx(
              o,
              {
                text: a,
                variant: "body-new/regular",
                textColor: "color/fg/lighter"
              }
            )
          ] })
        ] }),
        l && /* @__PURE__ */ e.jsx(
          j,
          {
            name: "chevron-down",
            size: "md",
            ...d
          }
        )
      ]
    }
  );
}, z = u(g);
export {
  g as AvatarLabel,
  z as default
};
//# sourceMappingURL=AvatarLabel.js.map
